import React from "react";
import { useTranslation } from "react-i18next";
import { useListEdition } from "@planzone/view-models";
import { DateTimeInput } from "@common/dateTimeInput";
import { Props } from "./types";
import styles from "./styles.scss";

function DatesPickers({ list, isInvalid, readOnly }: Props) {
  const { t } = useTranslation();
  const [startDate, setStartDate] = React.useState(list.startDate);
  const [endDate, setEndDate] = React.useState(list.endDate);
  const start = new Date(startDate || new Date());
  const end = new Date(endDate || new Date());
  const { editList } = useListEdition();

  React.useEffect(() => {
    setStartDate(list.startDate);
  }, [list.startDate]);

  React.useEffect(() => {
    setEndDate(list.endDate);
  }, [list.endDate]);

  return (
    <div className={styles.datesWrapper}>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("listRetrieval.startDate")}</h3>
        <DateTimeInput
          dateTime={startDate}
          placeholder={t("listRetrieval.startDate")}
          isInvalid={isInvalid}
          readOnly={readOnly}
          input={(date) => {
            const nextDate = new Date(date);

            editList({
              list,
              nextList: {
                ...list,
                startDate:
                  nextDate.toISOString() ===
                  new Date(list.startDate).toISOString()
                    ? ""
                    : nextDate.toISOString(),
              },
            });
          }}
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.title}>{t("listRetrieval.endDate")}</h3>
        <DateTimeInput
          dateTime={endDate}
          placeholder={t("listRetrieval.endDate")}
          isInvalid={isInvalid}
          readOnly={readOnly}
          input={(date) => {
            const nextDate = new Date(date);

            editList({
              list,
              nextList: {
                ...list,
                endDate:
                  nextDate.toISOString() ===
                  new Date(list.endDate).toISOString()
                    ? ""
                    : nextDate.toISOString(),
              },
            });
          }}
        />
      </div>
    </div>
  );
}

export { DatesPickers };
